var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickSicon3Mob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8028 4.21334C19.8977 4.3116 19.901 4.47782 19.8106 4.58009L19.3066 5.16623H21.9031L21.5753 2.52795L21.1169 3.06099C21.0221 3.17533 20.8375 3.18828 20.7275 3.08846C19.7784 2.25641 18.7083 1.5743 17.5471 1.06107C15.9537 0.356989 14.2556 0 12.5 0C10.8132 0 9.17612 0.330676 7.63409 0.982805C6.14571 1.61228 4.80904 2.51337 3.6611 3.66117C2.5133 4.80911 1.61221 6.14585 0.982737 7.63416C0.330608 9.17619 0 10.8133 0 12.5C0 14.1868 0.330676 15.8239 0.982804 17.3659C1.61228 18.8543 2.51337 20.191 3.66117 21.3389C4.80911 22.4867 6.14585 23.3879 7.63416 24.0173C9.17578 24.6694 10.8129 25 12.5 25C14.1871 25 15.8242 24.6693 17.3658 24.0173C18.8542 23.3879 20.1909 22.4867 21.3389 21.3389C22.4866 20.191 23.3878 18.8542 24.0173 17.3659C24.6339 15.9082 24.9631 14.3649 24.9971 12.7748H23.542C23.3957 18.7388 18.4987 23.5454 12.5 23.5454C6.40966 23.5454 1.45468 18.5905 1.45468 12.5C1.45468 6.40966 6.40959 1.45468 12.5 1.45468C13.8519 1.45468 15.1665 1.69176 16.4074 2.15936C17.6446 2.6256 18.7807 3.31042 19.7841 4.19482C19.7903 4.20099 19.7966 4.20716 19.8028 4.21334Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11719 9.70947V15.6077L12.2252 18.5567V12.6585L7.11719 9.70947Z",
    fill: "#1361F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5025 6.28467L7.39453 9.23376L12.5025 12.1828L17.6105 9.23376L12.5025 6.28467Z",
    fill: "#1361F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8812 9.70957L12.7733 12.6586V18.5568L17.8812 15.6078V9.70957Z",
    fill: "#1361F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSicon3Mob);
export default __webpack_public_path__ + "static/media/quick_sicon3_mob.48c53f574a9b5a82a141598fa2b0317e.svg";
export { ForwardRef as ReactComponent };